import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import isHotkey from 'is-hotkey';


import BaseElement from './BaseElement';
import { parseDate, noop } from 'utils';

export function renderStaticHeaderElement(params) {
  return (props) => {
    if (props.element.type === 'static-header') { 
      return (
          <StaticHeaderElement {...props} {...params} />
      );
    }
  
    return undefined;
  }
}

export const StaticHeaderPlugin = (params = {}) => ({
  renderElement: renderStaticHeaderElement(params),
});


export default function StaticHeaderElement({ attributes, index, element, children, ...props }) {
  const { t } = useTranslation()
  
  return (
    <BaseElement element={element} type="header" {...props} contentStyle={{textAlign: 'justify'}} {...attributes}>
      {({ isEmpty }) => (
        <React.Fragment>
          { isEmpty && <BaseElement.Placeholder text={t('editor.items.header')} /> }
          {/* <p {...attributes} style={{textAlign: "justify"}}> */}
            {children}
          {/* </p> */}
        </React.Fragment>
      )}
    </BaseElement>
  )
}